import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectReducer from '@utils/injectReducer';
import injectSaga from '@utils/injectSaga';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { connectToMirrorSession, disconnectFromMirrorSession } from './actions';
import reducer from './reducer';
import saga from './saga';
import { HiddenVideoPlaceholder, VideoPlaceholder } from './styles';
import VideoMonitorService from '@services/videoMonitorService';
import { EmptyMirror } from './icons/empty-mirror';

export class VideoMonitor extends Component {
  componentDidMount() {
      this.connectToMirror();
  }

  componentDidUpdate(prevProps) {
    const { connectedToMirror, displayMirror } = this.props;
    if (prevProps.connectedToMirror !== connectedToMirror
      && prevProps.displayMirror !== displayMirror
    ) {
      this.connectToMirror();
    }
  }

  componentWillUnmount() {
    const {
      connectedToMirror,
      dispatchDisconnectFromMirrorSession,
    } = this.props;
    if (connectedToMirror) {

      dispatchDisconnectFromMirrorSession(VideoMonitorService.archiveId);
    }
  }

  connectToMirror() {
    const {
      connectedToMirror,
      displayMirror,
      dispatchConnectToMirrorSession,
      isLesson,
    } = this.props;

    if (!connectedToMirror && displayMirror) {
      const withScreenRecording = isLesson ? false : true;
      dispatchConnectToMirrorSession(withScreenRecording, isLesson);
    }
  }

  render() {
    const { error, displayMirror } = this.props;
    if (error) return <EmptyMirror />;
    if (!displayMirror) return <HiddenVideoPlaceholder id='publisher' />;
    return <VideoPlaceholder id='publisher' />;
  }
}

VideoMonitor.propTypes = {
  error: PropTypes.string,
  connectedToMirror: PropTypes.bool,
  displayMirror: PropTypes.bool,
  dispatchConnectToMirrorSession: PropTypes.func,
  dispatchDisconnectFromMirrorSession: PropTypes.func,
};

export const mapStateToProps = (state) => {
  const { error, connectedToMirror } = state.getIn(['videoMirror'])
    ? state.getIn(['videoMirror']).toJS()
    : {};
  const { activityContext } = state.getIn(['course']).toJS();
  return { error, connectedToMirror, activityContext };
};

export function mapDispatchToProps(dispatch) {
  return {
    dispatchConnectToMirrorSession: (withScreenRecording, isLesson) => dispatch(connectToMirrorSession(withScreenRecording, isLesson)),
    dispatchDisconnectFromMirrorSession: (archiveId) =>
    dispatch(disconnectFromMirrorSession(archiveId)),
   };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({ key: 'videoMirror', reducer });
const withSaga = injectSaga({ key: 'videoMirror', saga });

export default compose(
  withConnect,
  withReducer,
  withSaga
)(VideoMonitor);
